var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 712 500"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M696.946 78.2331C688.768 47.4388 664.672 23.1862 634.078 14.9557C578.624 0 356.259 0 356.259 0C356.259 0 133.895 0 78.4392 14.9557C47.845 23.1875 23.7493 47.4388 15.5711 78.2331C0.712158 134.049 0.712158 250.505 0.712158 250.505C0.712158 250.505 0.712158 366.961 15.5711 422.777C23.7493 453.572 47.845 476.814 78.4392 485.044C133.895 500 356.259 500 356.259 500C356.259 500 578.622 500 634.078 485.044C664.672 476.814 688.768 453.572 696.946 422.777C711.805 366.961 711.805 250.505 711.805 250.505C711.805 250.505 711.805 134.049 696.946 78.2331ZM283.533 356.238V144.772L469.386 250.508L283.533 356.238Z"
  })));
};

export default SvgYoutube;